import { Navigate } from "react-router-dom";

import Navigation from "../../components/navBar/navBarGuest/Navigation";
import { useAuth } from "../../context/AuthContext";
import { LocaleContext } from "../../context/LocaleContext";
export const Layout = ({ children }) => {
  const { isAuth } = useAuth();
  return !isAuth ? (
    <LocaleContext.Consumer>
      {({ handleSetLocale }) => (
        <>
          <Navigation handleSetLocale={handleSetLocale} />
          {children}
        </>
      )}
    </LocaleContext.Consumer>
  ) : (
    // <Navigate to="/ViewerPage" />
    <Navigate to="/home" />
  );
};
